// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a55556fa","977":"bbeb5fbb"}[chunkId] + ".chunk.js";
};